
import { defineComponent } from "vue";
import api, { SheqsyArchive } from "../../api/backend-api";
import { getHumanDate } from "../../util/luxonDateHelpers"
import { AxiosError } from "axios";
import ErrorBlock from "@/components/ErrorBlock.vue";

interface State {
  msg: string;
  archive: SheqsyArchive;
  errors: AxiosError[];
}

export default defineComponent({
  name: "SheqsyArchiveForm",
  components: { ErrorBlock },
  mounted() {
    this.$nextTick(() => {
      this.callGetSheqsyArchive();
    });
  },
  data: (): State => {
    let sheqsyarchive = { } as SheqsyArchive;
    return {
      msg: "Sheqsy Event",
      archive: sheqsyarchive,
      errors: [],
    };
  },
  methods: {
    getHumanDate,
    getDownload(id: string) {
      api.getSheqsyArchive(id).then(response => {
        const blob = new Blob([JSON.stringify(response.data)], { type: 'text/json' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = 'SheqsyActivityArchive-' + id + '.json'
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
    },
    deleteArchive(id: string) {
      api.deleteSheqsyArchive(id).then(() => {
        this.$router.go(0)
      });
    },
    callGetSheqsyArchive() {

      let event_id = '';
      if (typeof this.$route.params.slug != 'string') {
        throw new Error("Invalid url");
      }
      event_id = this.$route.params.slug
      this.errors = [];

      api
        .getSheqsyArchive(event_id)
        .then((response) => {
          this.archive = response.data;
        })
        .catch((error: AxiosError) => {
          this.errors.push(error.response?.data.message);
        });
    },
  }
});
